import { CouponCatalogApi } from 'api/ApiHelper';
import { useQuery } from '@tanstack/react-query';
import { couponCatalogQueryKey } from 'queries/couponCatalog/queryKeys';

export const useGetIssuedCouponCatalogQuery = (couponCatalogId: number, enabled = false) =>
  useQuery({
    queryKey: couponCatalogQueryKey.couponCatalog(couponCatalogId),
    queryFn: () => CouponCatalogApi.getIssuedCoupons(couponCatalogId),
    enabled,
  });
